import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageALEAGUE9 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Unite Round Preview",
            author: "footballgirl",
            date: "December 9, 2023",
            imageGradient: "linear-gradient(135deg, #000000 0%, #ffa500 100%)",
            content: `<p>All teams descend on Sydney for a festival of football. We preview the matchups for the inaugural Unite Round.</p>`,
            navIndices: { prev: 'aleague-8', next: 'aleague' }
        });
    }

    init() {
        console.log('ArticlePageALEAGUE9 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to A-League
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'aleague' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_a.png';
            leagueLogo.alt = 'A-League';
        }
    }
}